import municipalities from './br-municipalities'
import taxRegimes from './br-tax-regimes'

/**
 * Export the `municipalities` array as `brMunicipalities`.
 * @type {Array}
 */
export const brMunicipalities = municipalities
export const brTaxRegimes = taxRegimes
